import {firmantesApi} from "../view/firmante.service";
import {buildFiltersUrl, reshape_response} from "../../../../helpers/functions";


export const getFirmantes = firmantesApi.injectEndpoints({
    endpoints: (builder) => ({
        getFirmantes: builder.query({
            query: ({filter_params}) => ({
                url: buildFiltersUrl("/v1/api/firmante/", filter_params),
                method: "GET",
            }),
            providesTags: (result) =>
                Array.isArray(result)
                    ? [
                        ...result.map(({id}) => ({
                            type: "Firmantes",
                            id,
                        })),
                        {type: "Firmantes", id: "LIST"},
                    ]
                    : [{type: "Firmantes", id: "LIST"}],
            transformResponse: (response, meta, args) => {
                if (Array.isArray(response)) {
                    return response?.map((el) => reshape_response(el, args.shape));
                } else {
                    const resultsTransformed = response?.results?.map((el) =>
                        reshape_response(el, args.shape)
                    );

                    // Devolvemos los resultados transformados junto con las propiedades de paginación
                    return {
                        results: resultsTransformed,
                        count: response.count,
                        next: response.next,
                        previous: response.previous,
                    };
                }
            },
        }),
    }),
})

export const {
    useGetFirmantesQuery,
} = getFirmantes;